import type { EventModuleKey, ResolvedEventModule } from '@conference/shared';

export interface ModuleNavigationTab {
  id: EventModuleKey | 'contacts';
  label: string;
  path: string;
}

const EXPLORE_PATHS: Partial<Record<EventModuleKey, string>> = {
  papers: '/explore/papers',
  speakers: '/explore/speakers',
  exhibitors: '/explore/exhibitors',
  sponsors: '/explore/sponsors',
  industry_partners: '/explore/industry-partners',
  committee: '/explore/committee',
  attendees: '/explore/attendees',
};

const MODULE_DESTINATIONS: Partial<Record<EventModuleKey, string>> = {
  ...EXPLORE_PATHS,
  agenda: '/agenda',
  venue_map: '/map',
  messaging: '/messages',
  ai_copilot: '/report-builder',
  notes: '/notes',
  recap: '/recap',
};

const LIBRARY_PATHS: Partial<Record<EventModuleKey, string>> = {
  notes: '/library',
  agenda: '/library/agenda',
  papers: '/library/papers',
  speakers: '/library/speakers',
  exhibitors: '/library/exhibitors',
};

function moduleTabs(
  modules: readonly ResolvedEventModule[],
  paths: Partial<Record<EventModuleKey, string>>,
): ModuleNavigationTab[] {
  return modules.flatMap((module) => {
    const path = paths[module.key];
    return module.enabled && path
      ? [{ id: module.key, label: module.label, path }]
      : [];
  });
}

export function getExploreNavigation(
  modules: readonly ResolvedEventModule[],
): ModuleNavigationTab[] {
  return moduleTabs(modules, EXPLORE_PATHS);
}

export function getLibraryNavigation(
  modules: readonly ResolvedEventModule[],
): ModuleNavigationTab[] {
  return [
    ...moduleTabs(modules, LIBRARY_PATHS),
    { id: 'contacts', label: 'Contacts', path: '/library/contacts' },
  ];
}

export function getActiveNavigationTab(
  pathname: string,
  tabs: readonly ModuleNavigationTab[],
): ModuleNavigationTab | null {
  return tabs.find((tab) => tab.path === pathname) ?? tabs[0] ?? null;
}

export function getModuleDestination(key: EventModuleKey): string | null {
  return MODULE_DESTINATIONS[key] ?? null;
}
